/**
 * Der Lernstand aus dem öffentlichen Kurs — im Browser gemerkt.
 *
 * Die Lernstrecke Skills4Retail steht unter `/skills4retail` auch ohne
 * Anmeldung offen. Wer sie dort durchgeht, hat kein Konto, in dem der Stand
 * liegen könnte; er liegt deshalb im `localStorage` dieses Geräts — je Kapitel
 * das **beste** Ergebnis, genau wie es der Server für angemeldete Personen hält.
 *
 * Sobald sich jemand anmeldet, wandert der Stand ins Konto
 * (`shared/useCourseProgressImport`) und wird hier gelöscht. Bis dahin gilt:
 * anderes Gerät, anderer Stand — das sagt die Einladung zur Anmeldung auch.
 *
 * **Nichts Personenbezogenes.** Gespeichert werden Kapitelnummer und Punktzahl,
 * kein Name, keine Kennung. Wer den Browser aufräumt, räumt den Stand mit weg.
 */

const SCHLUESSEL = 'junior:s4r-kurs'

/** Was hier eintrifft, hat jemand von Hand ändern können — deshalb geprüft. */
const istEintrag = eintrag =>
	eintrag &&
	Number.isInteger(eintrag.chapter) &&
	Number.isInteger(eintrag.correct) &&
	Number.isInteger(eintrag.total) &&
	eintrag.chapter > 0 &&
	eintrag.correct >= 0 &&
	eintrag.total > 0

export const leseKursstand = () => {
	try {
		const roh = window.localStorage.getItem(SCHLUESSEL)
		if (!roh) return []

		const daten = JSON.parse(roh)

		return Array.isArray(daten) ? daten.filter(istEintrag) : []
	} catch (error) {
		// Kaputter oder gesperrter Speicher heisst „kein Stand" — nie ein Fehler.
		return []
	}
}

/**
 * Ein Ergebnis ablegen. Es wird nichts kleiner: Ein schwächerer Versuch
 * überschreibt kein besseres Ergebnis, dieselbe Regel wie am Server.
 */
export const merkeKursstand = ({ chapter, correct, total }) => {
	const stand = leseKursstand()
	const vorher = stand.find(eintrag => eintrag.chapter === chapter)

	const neu = vorher
		? stand.map(eintrag =>
				eintrag.chapter === chapter
					? { ...eintrag, correct: Math.max(eintrag.correct, correct), total }
					: eintrag
		  )
		: [...stand, { chapter, correct, total }]

	try {
		window.localStorage.setItem(SCHLUESSEL, JSON.stringify(neu))
	} catch (error) {
		// Privater Modus oder voller Speicher: Der Kurs läuft weiter, nur ohne
		// Gedächtnis. Eine Fehlermeldung mitten im Quiz wäre die schlechtere Wahl.
	}

	return neu
}

export const loescheKursstand = () => {
	try {
		window.localStorage.removeItem(SCHLUESSEL)
	} catch (error) {
		// siehe oben
	}
}

/** Wie viele Kapitel über der Hürde liegen. */
export const bestandeneKapitel = (stand, quizPass) =>
	(stand || []).filter(eintrag => eintrag.correct >= quizPass).length
